import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadPageContent, handlePageLinkClick } from '../utils/pageHelpers';
import { PageSkeleton } from '../components/Loading';
import '../styles/BoardDetail.css';

interface InfoPageProps {
  subpage?: string;
}

const InfoPage: React.FC<InfoPageProps> = ({ subpage = 'law' }) => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const contentRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        let url = '';

        if (subpage === 'law' || subpage === 'law1' || subpage === 'law2' || subpage === 'law3' || subpage === 'law4') {
          url = `/cloneTarget/www.keso.kr/${subpage}.html`;
        } else {
          url = `/cloneTarget/www.keso.kr/info/${subpage}.html`;
        }

        const fullContent = await loadPageContent(url);
        setContent(fullContent);
      } catch (error) {
        console.error('Error loading content:', error);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [subpage]);

  useEffect(() => {
    if (!contentRef.current) return;

    const contentElement = contentRef.current;
    const linkClickHandler = (e: Event) => handlePageLinkClick(e, navigate);

    contentElement.addEventListener('click', linkClickHandler, true);
    window.scrollTo(0, 0);

    return () => {
      contentElement.removeEventListener('click', linkClickHandler, true);
    };
  }, [content, navigate]);

  if (loading) {
    return <PageSkeleton />;
  }

  return (
    <div ref={contentRef} dangerouslySetInnerHTML={{ __html: content }} />
  );
};

export default InfoPage;
